interface Props {
  color?: string
  width?: number
  height?: number
}

export const ShadowIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5 3C20.7761 3 21 3.22386 21 3.5V17.5C21 19.433 19.433 21 17.5 21H3.5C3.22386 21 3 20.7761 3 20.5C3 20.2239 3.22386 20 3.5 20H17.5C18.8807 20 20 18.8807 20 17.5V3.5C20 3.22386 20.2239 3 20.5 3ZM17 0C18.1046 0 19 0.89543 19 2V17C19 18.1046 18.1046 19 17 19H2C0.89543 19 0 18.1046 0 17V2C0 0.89543 0.89543 0 2 0H17ZM2 1C1.44772 1 1 1.44772 1 2V17C1 17.5523 1.44772 18 2 18H17C17.5523 18 18 17.5523 18 17V2C18 1.44772 17.5523 1 17 1H2Z"
        fill={color}
      />
    </svg>
  )
}
